export default function fromGlobalId(globalId) {
  try {
    return Buffer.from(globalId, 'base64').toString('utf-8').split(':').pop();
  } catch (_) {
    return '';
  }
}
